module.exports = __webpack_public_path__ + "media/images/countryrect/fo-b307681a3b688f93b9db3d1cce9350f7.svg";